import { jsx as _jsx } from "react/jsx-runtime";
import { v4 as uuidv4 } from 'uuid';
import { useState } from 'react';
import AddAlertButton from '../product/cta/buttons/AddAlertButton';
import AddToBasketButton from '../product/cta/buttons/AddToBasketButton';
import AvailableSoonButton from '../product/cta/buttons/AvailableSoonButton';
export const MultiProductCta = ({ selectedVariant1, selectedVariant2, selectedItem1, selectedItem2, }) => {
    const [idButton] = useState(uuidv4());
    const isAvailable = selectedItem1.available && selectedItem2.available;
    const isPreorder = selectedVariant1.preorder || selectedVariant2.preorder;
    const isAvailableSoon = selectedVariant1.availableSoon || selectedVariant2.availableSoon;
    const isInOtherBasket = selectedItem1.inOtherBasket || selectedItem2.inOtherBasket;
    let mainCta = _jsx(AddAlertButton, { soon: isAvailableSoon });
    if (isAvailableSoon) {
        mainCta = _jsx(AvailableSoonButton, {});
    }
    else if (isAvailable || isInOtherBasket) {
        mainCta = (_jsx(AddToBasketButton, { isAvailable: isAvailable, isPreorder: isPreorder, isInOtherBasket: isInOtherBasket, preorderDate: selectedVariant1.preorderDate || selectedVariant2.preorderDate, preorderDateEnd: selectedVariant1.preorderDateEnd || selectedVariant2.preorderDateEnd, addedToCart: false, isLoading: false, id: idButton }));
    }
    return mainCta;
};
